import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'spb-primary-link',
  templateUrl: './primary-link.component.html',
  styleUrls: ['./primary-link.component.scss'],
})
export class PrimaryLinkComponent implements OnInit {
  @HostBinding('class.spb-primary-anchor') hostBaseClass = true;
  @Input() hrefLinkUrl = '#';
  @Input() isHoverState: boolean;
  safeHrefLinkUrl: any;


  constructor(private domSanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.safeHrefLinkUrl = this.domSanitizer.bypassSecurityTrustUrl(this.hrefLinkUrl);
  }

}
